import { NormalizedEntity } from 'Interfaces/Common';
import { TeamMember } from 'Interfaces/Team';
import { omit } from 'lodash-es';
import { createReducer } from 'typesafe-actions';

import {
  deleteTeamMembers,
  downgradeToUser,
  freezeTeamMembers,
  getTeamMembers,
  unfreezeTeamMembers,
  upgradeToAdmin,
} from './actionCreators';

export default createReducer({} as NormalizedEntity<TeamMember>)
  .handleAction(
    [getTeamMembers.success, freezeTeamMembers.success, unfreezeTeamMembers.success],
    (state, action) => ({
      ...action.payload.teamMembers,
    }),
  )
  .handleAction(deleteTeamMembers.success, (state, action) => {
    const newState = omit(state, action.payload.teamMembersIds);

    return newState;
  })
  .handleAction([upgradeToAdmin.success, downgradeToUser.success], (state, action) => ({
    ...state,
    [action.payload.id]: { ...state[action.payload.id], ...action.payload },
  }));
